import React from 'react';
import PropTypes from 'prop-types';
import { Heart } from 'lucide-react';
import styles from '../../PortfolioHeader.module.scss';

const ShortlistButton = ({
  toggleShortlist,
  shortlistState,
  name,
  disabled,
}) => (
  <button
    type="button"
    onClick={toggleShortlist}
    disabled={disabled}
    className={`${styles.saveButton} ${shortlistState ? styles.saved : ''}`}
    aria-pressed={!!shortlistState}
    aria-label={shortlistState ? `Remove ${name} from saved` : `Save ${name}`}
    title="Adds/Removes freelancer from your Talent Pool"
  >
    <Heart
      size={20}
      strokeWidth={2}
      fill={shortlistState ? 'currentColor' : 'none'}
      aria-hidden="true"
    />
  </button>
);

ShortlistButton.propTypes = {
  toggleShortlist: PropTypes.func,
  shortlistState: PropTypes.bool,
  name: PropTypes.string,
  disabled: PropTypes.bool,
};

export default ShortlistButton;
